<template>
  <div style="margin-left:40px;" class="mt-1" v-if="elementTypeQuestion == 'notation'">
    <div>
      <p
        >{{ $t("question.choix.maxnote") }} &nbsp;</p
      >
      <div>
        <b-icon type="is-warning" pack="fas" icon="star"></b-icon>
        <b-icon type="is-warning" pack="fas" icon="star"></b-icon>
        <b-icon type="is-warning" pack="fas" icon="star"></b-icon>
        <b-icon pack="fas" icon="star"></b-icon>
        <b-icon pack="fas" icon="star"></b-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notation',
  props: {
    elementTypeQuestion: String
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/question/components/Notation.vue